import Button from "./Common/Button";
import { useNavigate } from 'react-router-dom';
// const BrowserHistory = require('react-router/lib/BrowserHistory').default;

export default function BackButton () {
    const navigate = useNavigate();
    return <Button type='btn-outline-custom' clickHandler={() => navigate(-1)}>
        <i className='fa fa-chevron-left mr-1'></i>Back
    </Button>
}